export const SET_WORKOUT_PLANS = 'SET_WORKOUT_PLANS';
export const SET_WORKOUT_PLAN_BY_ID = 'SET_WORKOUT_PLAN_BY_ID';
export const RESET_WORKOUT_PLAN_BY_ID = 'RESET_WORKOUT_PLAN_BY_ID';
export const RESET_WORKOUT_PLANS = 'RESET_WORKOUT_PLANS';
